/**
 * @Author: Anandp
 * @Date:   2024-04-17 18:40:50
 * @Last Modified by:   Anandp
 * @Last Modified time: 2024-12-23 22:04:18
 */
import axios from "axios";
import { Url, siteConstant } from "src/config";
import CryptoJS from 'crypto-js';
let pendingDashboardIdsPromiseMap = new Map();
let dashboardIdsCacheMap = new Map();
let dashboardIdsCacheTimestampMap = new Map();

let pendingSurveyIdsPromiseMap = new Map();
let surveyIdsCacheMap = new Map();
let surveyIdsCacheTimestampMap = new Map();

const loginApiService = {
  checkLogin: async () => {
    try {
      const response = await axios.post(`${Url}/module/profile`);
      return response.data;
    } catch (error) {
      console.log(error.message);
    }
  },
  userLogout: async () => {
    try {
      const accessToken = sessionStorage.getItem(siteConstant.AUTH_TOKEN_STORAGE_KEY);
      const response = await axios.post(`${Url}/auth/logout`, {}, {
        headers: {
          "access-token": accessToken,
        },
      });    
      return response.data;
    } catch (error) {
      console.log(error.message);
    }
  },
  getProvider: async (data) => {
    //Get sso-provider
    try {
      const response = await axios.post(`${Url}/auth/sso-provider`, data);
      return response.data;
    } catch (error) {
      console.log(error.message);
    }
  },
  getDashboardIds: async (accessToken, id) => {
    const cacheKey = id ? id.toString() : 'default';
    const now = Date.now();

    if (dashboardIdsCacheMap.has(cacheKey) && (now - (dashboardIdsCacheTimestampMap.get(cacheKey) || 0) < 5000)) {
      return dashboardIdsCacheMap.get(cacheKey);
    }
    if (pendingDashboardIdsPromiseMap.has(cacheKey)) {
      return pendingDashboardIdsPromiseMap.get(cacheKey);
    }

    const promise = (async () => {
      try {
        const response = await axios.get(`${Url}/customer/getdashboardperms?userId=${id}`, {
          withCredentials: true
        });
        const numberArray = response?.data?.dashIds?.map(Number);
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(numberArray), id.toString()).toString();
        sessionStorage.setItem("dashboardPerms", encrypted);
        if (localStorage.getItem("remberMe") === "true") {
          localStorage.setItem("dashboardPerms", encrypted);
        }
        window.dispatchEvent(new Event('storage'));
        dashboardIdsCacheMap.set(cacheKey, response.data);
        dashboardIdsCacheTimestampMap.set(cacheKey, Date.now());
        return response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        pendingDashboardIdsPromiseMap.delete(cacheKey);
      }
    })();

    pendingDashboardIdsPromiseMap.set(cacheKey, promise);
    return promise;
  },
  getSurveyIds: async (accessToken, id) => {
    const cacheKey = id ? id.toString() : 'default';
    const now = Date.now();

    if (surveyIdsCacheMap.has(cacheKey) && (now - (surveyIdsCacheTimestampMap.get(cacheKey) || 0) < 5000)) {
      return surveyIdsCacheMap.get(cacheKey);
    }
    if (pendingSurveyIdsPromiseMap.has(cacheKey)) {
      return pendingSurveyIdsPromiseMap.get(cacheKey);
    }

    const promise = (async () => {
      try {
        console.log('--inisde get survey permissions--');
        
        const response = await axios.get(`${Url}/customer/getsurveyperms?userId=${id}`, {
          withCredentials: true
        });
        
        const surveyIds = response?.data?.surveyIds ? response?.data?.surveyIds : response?.data?.SurveyIds;
        const numberArray = surveyIds.map(Number);
        console.log("Fetched survey IDs:", numberArray);
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(numberArray), id.toString()).toString();
        sessionStorage.setItem("surveyPerms", encrypted);
        if (localStorage.getItem("remberMe") === "true") {
          localStorage.setItem("surveyPerms", encrypted);
        }
        window.dispatchEvent(new Event('storage'));
        surveyIdsCacheMap.set(cacheKey, response.data);
        surveyIdsCacheTimestampMap.set(cacheKey, Date.now());
        return response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        pendingSurveyIdsPromiseMap.delete(cacheKey);
      }
    })();

    pendingSurveyIdsPromiseMap.set(cacheKey, promise);
    return promise;
  },
  acceptUserConsent: async (data, accessToken) => {
    //Accept user consent
    try {
       // eslint-disable-next-line
      const response = await axios.post(`${Url}/auth/user-consent`, data);
      // const token = response.headers["x-access-token"];
      // sessionStorage.setItem(siteConstant.AUTH_TOKEN_STORAGE_KEY, token);
      return ;
    } catch (error) {
      console.log(error.message);
    }
  },
};


export default loginApiService;
